$(document).ready(function () {
  const forms = document.querySelectorAll('.js-invest-form');

  for (const form of forms) {
    const $submitButton = $(form).find('.js-subscribe-submit-button');
    const $subscriptionAmountField = $(form).find('#subscription_amount_field');
    const $warningModal = $(form).find('#NonInformedProfileWarningModal');
    const $subscribeModal = $(form).find('#subscribeModal');

    function handleFormSubmission() {
      let $amount = $subscriptionAmountField.val()

      if (!$subscriptionAmountField[0].checkValidity()) {
        form.querySelector('#fields_errors').innerHTML = getErrorMessage($subscriptionAmountField[0], $subscriptionAmountField[0].validity);
        return;
      } else {
        form.querySelector('#fields_errors').innerHTML = '';
      }

      if ($amount) {
        Rails.ajax({
          type: 'GET',
          url: $subscriptionAmountField.data('url'),
          data: '&[amount]=' + $amount,
          dataType: 'json',
          success: function(response) {
            let warning_modal_required = response['warning_modal_required']

            if (warning_modal_required) {
              $warningModal.modal('show');
            } else {
              $subscribeModal.modal('show');
            }
          },
          error: function() {
            form.querySelector('#fields_errors').innerHTML = "Une erreur s'est produite, veuillez réessayer.";
          }
        });
      }
      return false;
    }

    $submitButton.click(handleFormSubmission);
    $(form).find(".subscription-form").on("submit", handleFormSubmission);

    $warningModal.on('shown.bs.modal', function() {
      $(form).find('#NonInformedProfileWarningModal :input').prop('disabled', false);
    });
    $warningModal.on('hide.bs.modal', function() {
      $(form).find('#NonInformedProfileWarningModal :input').prop('disabled', true);
    });

    // We need to submit the form manually to avoid the automatic submission when clicking on "enter"
    // Due to the fact that we have on one side, one modal and one submit button; and on the other side, 2 inputs,
    // we need to do it this way with the "$(form)"
    $(form).find(".submit-btn").click(function() {
      const required_checkboxes = [
        "#subscription_new_simulations", "#subscription_investment_capacity", "#subscription_risk_awareness"
      ];

      if (required_checkboxes.every(field => $(field)[0].checkValidity())) {
        this.form.submit();
      }
    });
  };

  function getErrorMessage(field, validity) {
    if (validity.rangeOverflow) {
      return field.dataset.errorOverflow;
    } else if (validity.stepMismatch) {
      return field.dataset.errorStep;
    } else {
      return field.validationMessage;
    }
  };
});
